export default __webpack_public_path__ + "static/screenshot2-64c3d983897d4a627fa618811b271900.jpg";